// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-61d9f536] {\n  --magic-badge-background: rgba(255, 255, 255, 0.2);\n}", ""]);
// Exports
module.exports = exports;
